import script from "./AddZeroReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddZeroReport.vue?vue&type=script&setup=true&lang=ts"

import "./AddZeroReport.vue?vue&type=style&index=0&id=6beb949b&scoped=true&lang=css"

import exportComponent from "../../../../../../ss/MO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6beb949b"]])

export default __exports__